import { vars } from 'src/core/themes';

import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const TeamMembersIcon = (props: PosIconProps) => {
  return (
    <SvgWrapper
      {...props}
      viewBox="4 0 14 10.8  "
      size={vars.iconSize.s}
      fill={vars.color.iconPrimary}
    >
      <path
        d="M9.47656 6.83828C7.92574 6.83828 6.84828 7.20153 6.17422 7.71641C5.53084 8.20801 5.21678 8.86449 5.20156 9.6H13.7508C13.7356
  8.86448 13.4215 8.20801 12.7781 7.71641C12.1041 7.20157 11.0272 6.83834 9.47656 6.83828ZM10.7047 2.4C10.7047 1.74625 10.1639 1.2002
  9.47656 1.2C8.7891 1.2 8.24766 1.74613 8.24766 2.4C8.24766 3.05387 8.7891 3.6 9.47656 3.6C10.1639 3.5998 10.7047 3.05375 10.7047
  2.4ZM13.7141 2.4C13.7141 1.96131 13.4728 1.57305 13.1031 1.3625C12.8152 1.19853 12.7149 0.831708 12.8789 0.54375C13.0429 0.255984 13.409
  0.155607 13.6969 0.319531C14.4203 0.731463 14.9141 1.50625 14.9141 2.4C14.9141 3.29375 14.4203 4.06854 13.6969 4.48047C13.409 4.64439
  13.0429 4.54402 12.8789 4.25625C12.7149 3.96829 12.8152 3.60147 13.1031 3.4375C13.4728 3.22695 13.7141 2.83869 13.7141 2.4ZM14.9523
  9.65625C14.9523 10.2361 14.5107 10.7998 13.8555 10.8H5.09688C4.44163 10.7998 4.00002 10.2361 4 9.65625C4 8.52691 4.48653 7.49548 5.44609
  6.7625C6.39162 6.04026 7.75337 5.63828 9.47656 5.63828C11.1996 5.63834 12.5608 6.04032 13.5063 6.7625C14.4658 7.49548 14.9523 8.5269
  14.9523 9.65625ZM18 9.65625C18 10.2361 17.5584 10.7998 16.9031 10.8H16.6C16.2686 10.8 16 10.5314 16 10.2C16 9.86863 16.2686 9.6 16.6
  9.6H16.7969C16.7825 9.24759 16.6387 8.73811 16.3805 8.22109C16.1086 7.67686 15.7609 7.2226 15.4445 6.98984C15.1776 6.79354 15.1202 6.41772
   15.3164 6.15078C15.5127 5.88388 15.8885 5.82644 16.1555 6.02266C16.6839 6.41131 17.137 7.05008 17.4539 7.68438C17.7703 8.31765 18 9.04543
   18 9.65625ZM11.9047 2.4C11.9047 3.73423 10.8087 4.7998 9.47656 4.8C8.14424 4.8 7.04766 3.73436 7.04766 2.4C7.04766 1.06564 8.14424 0
  9.47656 0C10.8087 0.000198303 11.9047 1.06577 11.9047 2.4Z"
        fill="inherit"
      />
    </SvgWrapper>
  );
};
